// Persistance légère de la session de quiz (sessionStorage, même onglet).
// Permet de naviguer vers une fiche /mot/… puis de reprendre le quiz au
// retour exactement où il en était : mots en cours, question affichée,
// liste « à revoir », scores, série bonus, et thème actif (sinon le quiz
// thématique se perdait au retour).
// La session est ignorée si elle a plus d'une heure ou si la langue / la
// fréquence ne correspondent plus.
const KEY = 'motrusse_quiz_session';
const MAX_AGE_MS = 60 * 60 * 1000;

export function saveSession(data) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ v: 1, t: Date.now(), ...data }));
  } catch {}
}

export function loadSession(apiLang, frequency) {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (s.v !== 1 || Date.now() - s.t > MAX_AGE_MS) return null;
    if (s.lang !== apiLang || s.frequency !== frequency) return null;
    if (!Array.isArray(s.words) || !s.words.length || !s.currentWord) return null;
    return s;
  } catch {
    return null;
  }
}
